import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import CinematicNav, { BackToTop } from '../components/landing/CinematicNav'
import CinematicFooter from '../components/landing/CinematicFooter'
import PlatformHome from '../components/landing/PlatformHome'
import { useActiveIntake } from '../hooks/useActiveIntake'

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false)
  const [showBackToTop, setShowBackToTop] = useState(false)
  const [contactEmail, setContactEmail] = useState('synergymultimediaacademy@gmail.com')
  const { intake, fallback } = useActiveIntake()

  const navOverHero = !scrolled

  useEffect(() => {
    document.title = 'Synergy Multimedia Academy'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Learn creative skills and create real work. Practical education, professional tools, and real projects at Synergy Multimedia Academy.'
      )
    }
  }, [])

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (!hash) return undefined
    const timer = window.setTimeout(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' })
    }, 80)
    return () => window.clearTimeout(timer)
  }, [])

  useEffect(() => {
    const apiBase = import.meta.env.VITE_API_URL || '/api'
    fetch(`${apiBase}/auth/public-settings`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.email && !data.email.startsWith('info@')) setContactEmail(data.email)
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40)
      setShowBackToTop(window.scrollY > 800)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div className="cinema-page min-h-screen selection:bg-cinema-glow/30 selection:text-white">
      <Helmet>
        <title>Synergy Multimedia Academy</title>
        <meta
          name="description"
          content="Learn creative skills and create real work. Practical education, professional tools, and real projects at Synergy Multimedia Academy."
        />
        <link rel="canonical" href="https://synergymultimediaacademy.com/" />
        <meta property="og:title" content="Learn creative skills. Create real work. | Synergy Multimedia Academy" />
        <meta
          property="og:description"
          content="Practical creative education, professional tools and real-world opportunities for people building in the creative industry."
        />
        <meta property="og:url" content="https://synergymultimediaacademy.com/" />
      </Helmet>
      <div className="cinema-grain" aria-hidden="true" />

      <CinematicNav
        scrolled={scrolled}
        navOverHero={navOverHero}
        onNavigate={scrollToSection}
        intake={intake}
        fallback={fallback}
      />

      <main>
        <PlatformHome />
        <CinematicFooter contactEmail={contactEmail} closing={false} />
      </main>

      <BackToTop visible={showBackToTop} />
    </div>
  )
}
